/* hs-eslint ignored failing-rules */
/* eslint-disable prefer-promise-reject-errors */

import PortalIdParser from 'PortalIdParser';
import { createApiCache, MAX_CACHE_TIMEOUT } from './createApiCache';
import { ApiMap } from '../ApiMap';
const BrandColorsCache = {};
export function getFetchFavoriteColors(http) {
  const withBrandColors = createApiCache(http.get, ApiMap.BRAND_COLORS.getUrl, BrandColorsCache, MAX_CACHE_TIMEOUT);
  const portalId = PortalIdParser.get();
  return function fetchFavoriteColors() {
    return new Promise((resolve, reject) => {
      if (!http || !portalId) {
        const errorMsg = portalId ? 'An http client' : 'A portalId';
        reject(`Error: ${errorMsg} is needed to fetch favorite colors.`);
      } else {
        withBrandColors(portalId).then(brandColors => {
          resolve(brandColors.map(({
            color
          }) => color));
        }).catch(reject);
      }
    });
  };
}